import { option } from "fp-ts"
import { pipe } from "fp-ts/function"
import { ReactElement } from "react"

type F<T> = (t: T) => ReactElement

export const optionalRender =
  <T>(f: F<T>) =>
  (o: option.Option<T>) =>
    pipe(o, option.map(f), option.toNullable)
